module.exports = __webpack_public_path__ + "static/media/minotepad.9fa3d85e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minotepad.png
// module id = 63
// module chunks = 0